import client from '../client';
import * as fogQueries from '../queries/fog';
import * as fogMutations from "../mutations/fog";

export function getFogs(success, error, force = false, displayAllFogs = false) {
    let fetchPolicy = 'cache-first';
    let query = fogQueries.all;
    let variables = {};

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    if (displayAllFogs) {
        query = fogQueries.activeAndInactive;
        variables = { displayAll: true };
    }

    client.query({
        fetchPolicy: fetchPolicy,
        variables : {...variables},
        query: query,
    })
        .then(success)
        .catch(error);
}

export function edit(success, error, id, data) {
    client.mutate({
        variables: { id: id, fog: data },
        mutation: fogMutations.edit,
    })
    .then(success)
    .catch(error);
}

export function add(success, error, data) {
    client.mutate({
        variables: { fog: data },
        mutation: fogMutations.add,
    })
    .then(success).catch(error);
}

export function get(success, error, id, force = false) {
    let fetchPolicy = 'cache-first';

    if (force === true) {
        fetchPolicy = 'network-only';
    }

    client.query({
        fetchPolicy: fetchPolicy,
        variables: { id: id },
        query: fogQueries.get,
    })
    .then(success)
    .catch(error);
}


// WEBPACK FOOTER //
// ./src/graphql/actions/fog.js